import axios from 'axios';
import { API_URL } from '../../../url/api';

interface FormData {
  name: string;
  email: string;
  password: string;
  key : string;
}

// above is the api call for signup and signin
// Sign up function
async function signUp(formData: FormData): Promise<{ success: boolean, token: string, doctor: number , response ?: string }> {
  try {
    console.log('formData:', formData)
    const response = await axios.post(API_URL+'therapist/signup/', formData);
    return response.data;
  } catch (error) {
    console.error('Sign up failed:', error);
    throw error;
  }
}

// Sign in function
async function signIn(formData: { email: string, password: string }): Promise<{ success: boolean, token: string, user: number , response?: string }> {
  try {
    const response = await axios.post(API_URL+'therapist/signin/', formData);
    return response.data;
  } catch (error) {
    console.error('Sign in failed:', error);
    throw error;
  }
}

export {  signUp, signIn };